import { Button } from 'blaze-ui/Button'
import { ButtonProps } from 'blaze-ui/Button/Types'
import { forwardRef } from 'react'

interface Props extends Omit<ButtonProps, 'size' | 'variant' | 'color'> {}

const ToolbarButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  return <Button variant="editor" size="sm" color="var(--dark-80)" {...props} ref={ref} />
})

export { ToolbarButton }
